import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    selectedPerson: {}
}

export const personSlice = createSlice({
    name: 'person',
    initialState,
    reducers: {
        setSelectedPerson: (state, action) => {
            state.selectedPerson = action.payload
        }
    },
})

// Action creators are generated for each case reducer function
export const {setSelectedPerson} = personSlice.actions

export default personSlice.reducer
